import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import { OB_STEPS } from "../../../GettingStartedPage/utils/onboardingSteps"
import { createSteps } from "../../utils/constants/createSteps"
import { getAlertSubSteps } from "../../utils/helpers/getAlertSubSteps"
import { getStepState } from "../../utils/helpers/getStepState"
import OnboardingStep from "../OnboardingStep"
import OnboardingSubStep from "../OnboardingSubStep"

import "../../styles.less"

const OnboardingSideBar = ({ showSubSteps }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const nextStep = useSelector((state) => state.auth?.userInfo?.next_step)
  const enrollments = useSelector((state) => state.user.enrollments)

  const steps = createSteps(OB_STEPS)
  const isAlertPage = pathname.includes("/alerts")

  const activeEnrollments = enrollments?.filter((enrollment) => enrollment.is_active)
  const isActiveRDR = activeEnrollments.some((enrollment) => enrollment.name === "RDR")

  return (
    <div className="ob-steps">
      {steps.map((s, i) => {
        const { done, active, block, isProcess, isSub } = getStepState(
          s.stepId,
          nextStep,
          OB_STEPS,
          showSubSteps,
          isAlertPage
        )

        return (
          <>
            <OnboardingStep
              key={s.key}
              label={s.label}
              done={done}
              active={active}
              process={isProcess}
              sub={isSub}
              onClick={() => {
                if (block) return
                navigate(`/onboarding/${s.key}`)
              }}
            />

            {isSub && (
              <div className="ob-subSteps">
                {getAlertSubSteps(showSubSteps, s.subSteps)
                  .filter((ss) => ss.key !== "bin" || isActiveRDR)
                  .map((ss) => (
                    <OnboardingSubStep key={ss.key} {...ss} />
                  ))}
              </div>
            )}
          </>
        )
      })}
    </div>
  )
}

export default OnboardingSideBar
